import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import useCurrentUser from 'lib/hooks/useCurrentUser'
import { PGWStatus } from 'lib/utils/store/currentUser'
import { isProductionHost } from 'lib/env'
import { getLocale } from 'lib/utils/getLocale'

import ErrorComponent from 'components/Errors/ErrorComponent'
import Button from 'components/UI/Button'

import getBoardingUrlMutation from 'graphql/user/getBoardingUrl.gql'
import updatePgwStatusInfoMutation from 'graphql/user/updatePgwStatusInfo.gql'

import './user-identification-data-section.pcss'

const UserIdentificationDataSection = ({ identificationError }) => {
    const history = useHistory()
    const { t, i18n } = useTranslation('editProfile')
    const currentUser = useCurrentUser()
    const user = currentUser.me.user

    const lastIdentification = user.lastIdentification
    const userIdentified = !!lastIdentification

    const [getBoardingUrl, { loading: getBoardingUrlLoading, error: getBoardingUrlError }] = useMutation(getBoardingUrlMutation)
    const [updatePgwStatusInfo] = useMutation(updatePgwStatusInfoMutation)
    const path = `${getLocale(i18n.language)}/kayttaja/muokkaa`

    useEffect(() => {
        if (currentUser.me.pgwId && currentUser.me.pgwStatus !== PGWStatus.ACTIVE) {
            updatePgwStatusInfo({
                variables: {
                    pgwId: currentUser.me.pgwId
                },
            })
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const redirectToPgwBoardingUrl = () => {
        if (isProductionHost()) {
            getBoardingUrl({
                variables: {
                    successTarget: path,
                    failureTarget: path
                }
            }).then((result) => {
                window.location.href = result.data.getBoardingUrl
            })
        } else {
            history.push({
                pathname: `${getLocale(i18n.language)}/dev/user-identification-test-data-input`,
                state: {
                    successTarget: path,
                    failureTarget: path
                }
            })
        }
    }

    const userIdentifiedInfo = () => {
        return (
            <>
                <h2 className="user-identification-data-section__text">{t('editProfile:details.identification.detailText')}</h2>
                <div className="action-wrapper action-wrapper--right">
                    <Button
                        className="button button--tertiary"
                        title={t('editProfile:details.identification.linkText')}
                        trackName="identifyElectronically"
                        onClick={redirectToPgwBoardingUrl}
                        loading={getBoardingUrlLoading}
                    >
                        {t('editProfile:details.identification.linkText')}
                    </Button>
                </div>
            </>
        )
    }

    const userIdentification = () => {
        return <h2 className="user-identification-data-section__text">{t('editProfile:details.identification.text')}</h2>
    }

    return (
        <div className="user-identification-data-section">
            {userIdentified ? (
                userIdentifiedInfo()
            ) : (
                userIdentification()
            )}
            {(identificationError || getBoardingUrlError) && (
                <ErrorComponent
                    type="alert"
                    error={identificationError || getBoardingUrlError}
                    errorPage={false}
                    container={false}
                />
            )}
        </div>
    )
}

UserIdentificationDataSection.propTypes = {
    identificationError: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
}

export default UserIdentificationDataSection
